/**
 * AOSS 上传相关
 */

export default {
  // 上传接口: 返回完整地址
  fileUpload: `${process.env.VUE_APP_API_URL_UPLOAD}${process.env.VUE_APP_PREFIX_STR}/file/index/upfull?token=fsa`,
};
